var map = {
	"./1.jpg": 20264,
	"./IMG_0640.JPG": 19728,
	"./IMG_0641.JPG": 81527,
	"./IMG_0642.JPG": 12245,
	"./IMG_0643.JPG": 41157,
	"./IMG_0644.JPG": 15880,
	"./IMG_0645.JPG": 78029,
	"./IMG_0646.JPG": 60716,
	"./IMG_0647.JPG": 5489,
	"./IMG_0648.JPG": 8039,
	"./IMG_0649.JPG": 35698,
	"./IMG_0650.JPG": 25719,
	"./IMG_0651.JPG": 16173,
	"./IMG_0652.JPG": 5004,
	"./IMG_0653.JPG": 34006
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81525;